export const INTERNAL_LINKS = {
  HOME: '/',
  ATTEND: '/attend',
  COVID: '/covid',
  FAQ: '/faq',
};

export const EXTERNAL_LINKS = {
  TEAM: 'https://www.dubhacks.co/about#team',
  ABOUT_DH: 'https://www.dubhacks.co/about',
  CODE_OF_CONDUCT: 'https://static.mlh.io/docs/mlh-code-of-conduct.pdf',
  APPLY_FORM: 'https://airtable.com/shr4hbkgEutNMZ743',
  MENTOR_FORM: 'https://airtable.com/shrIb7uAadj2YZiPr',
};

export const REDIRECT_LINKS: Record<string, { link: string; target: string }> = {
  HACKER_APPLY: {
    link: '/apply',
    target: EXTERNAL_LINKS.APPLY_FORM,
  },
  MENTOR_SIGNUP: {
    link: '/mentor',
    target: EXTERNAL_LINKS.MENTOR_FORM,
  },
};
